/** Static copy for the claim intake. */
export const CLAIM_INTAKE_CONFIG = {
  repairDeadline: {
    label: 'Repair deadline',
    hint: 'When the shop or customer needs the repair done by.',
    openPicker: 'Open date picker',
  },
  usage: {
    atSale: (value: string) => `${value} at sale`,
    pairError: 'Select which reading this value is for.',
  },
} as const;
